import { ASSETS } from "assets";
import { PAGE_ROUTES } from "lib/constants/page-routes";
import { AppContext } from "lib/contexts/app-context";
import {
  isPatientUser,
  isPractitionerUser,
  isShowProfile,
} from "lib/utils/util";

import { FC, useContext } from "react";
import {
  Container,
  Image,
  Nav,
  Navbar,
  NavDropdown,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";

interface MainMenuProps {
  onSignOutUser: VoidFunction;
  setIsCollapsed?: (collapsed: boolean) => void;
  isCollapsed?: boolean;
}

const MainMenu: FC<MainMenuProps> = ({ onSignOutUser, setIsCollapsed, isCollapsed }) => {
  const navigateTo = useNavigate();
  const { appState } = useContext(AppContext);

  const handleProfileClick = () => {
    if (isPractitionerUser(appState.userRole)) {
      navigateTo(PAGE_ROUTES.PRACTITIONER.Profile);
    } else if (isPatientUser(appState.userRole)) {
      navigateTo(PAGE_ROUTES.PATIENT.Profile);
    }
  };

  return (
    <Navbar
      bg="primary"
      variant="dark"
      expand="md"
      className="main-menu shadow"
      fixed="top"
      collapseOnSelect
    >
      <Container fluid>
        <Navbar.Brand href={PAGE_ROUTES.Root} className="d-flex align-items-center">
          <Image
            src={ASSETS.IMAGES.LOGO}
            alt="HEAL"
            width={150}
            className="img-fluid"
          />
        </Navbar.Brand>

        <Navbar.Toggle
          aria-controls="main-navbar"
          className="border-0 shadow-none d-lg-none"
          onClick={() => {
            setIsCollapsed && setIsCollapsed(!isCollapsed);
          }}
        >
          {isCollapsed ? <FaBars /> : <FaTimes />}

        </Navbar.Toggle>

        <Navbar.Collapse id="main-navbar" className="justify-content-end d-none d-md-flex">
          <Nav className="align-items-center">
            <Nav.Link
              className="me-3"
              href="https://heal-3.gitbook.io/heal-docs/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Help
            </Nav.Link>

            <NavDropdown
              title={appState.name}
              id="navbarScrollingDropdown"
              align="end"
              className="text-white"
              menuVariant="light"
            >
              {isShowProfile(appState.userRole) && (
                <>
                  <NavDropdown.Item onClick={handleProfileClick}>
                    Profile
                  </NavDropdown.Item>
                  <NavDropdown.Divider />
                </>
              )}

              <NavDropdown.Item
                onClick={() =>
                  navigateTo(PAGE_ROUTES.AUTHENTICATION.ForgotPassword)
                }
              >
                Change Password
              </NavDropdown.Item>

              <NavDropdown.Item onClick={onSignOutUser}>
                Logout
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default MainMenu;
